export const url = "https://boibazaar.viserx.net";
export const local = "https://boibazaar.viserx.net";
// export const url = "http://127.0.0.1:8000";
// export const local = "http://127.0.0.1:8000/api/v1";
// export const local = "http://admin.boibazaar.com/api/v1";
